export default "__VITE_ASSET__xh4ZKi1f__"